import { render } from "./SJDeliveryRecord.vue?vue&type=template&id=e69cc77e&scoped=true"
import script from "./SJDeliveryRecord.vue?vue&type=script&lang=js"
export * from "./SJDeliveryRecord.vue?vue&type=script&lang=js"

import "./SJDeliveryRecord.vue?vue&type=style&index=0&id=e69cc77e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e69cc77e"

export default script